import { Box } from "@chakra-ui/react";
import { LanguageSwitcher } from "@root/components/language-switcher";
import React from "react";
import { Outlet } from "react-router-dom";

function FreeLayout() {
  return (
    <Box>
      <Box width={'fit-content'} p={'16px'}>
        <LanguageSwitcher />
      </Box>
      <Outlet />
    </Box>
  );
}

export default FreeLayout;
